import React, { useEffect, useState } from 'react'
import { useLoader } from '../context/LoaderContext';
import { IBannerData, ICouncilMemberData, IFounderMessageData } from '../exports/interfaces';
import { fetchFounderBanner, fetchFounderMember, fetchFounderMessage } from '../api/CouncilApi';
import { dynamicFailed } from '../hooks/useToast';
import FounderBanner from '../components/founder/FounderBanner';
import FounderMember from '../components/founder/FounderMember';
import FounderMessage from '../components/founder/FounderMessage';

const Founder = () => {
    const { setLoading } = useLoader();
      const [founderBannerData, setFounderBannerData] = useState<IBannerData[]>([]);
      const [founderMemberData, setFounderMemberData] = useState<
        ICouncilMemberData[]
      >([]);
      const [founderMessageData, setFounderMessageData] = useState<IFounderMessageData[]>([]);
      useEffect(() => {
        setLoading(true);
        Promise.all([fetchFounderBanner(), fetchFounderMember(), fetchFounderMessage()])
          .then(([councilData, councilMemberData, founderMessage]) => {
            setFounderBannerData(councilData);
            setFounderMemberData(councilMemberData);
            setFounderMessageData(founderMessage);
            setTimeout(() => {
              setLoading(false);
            }, 1000);
          })
          .catch(() => {
            dynamicFailed("Server Error");
            setTimeout(() => {
              setLoading(false); 
            }, 1000);
          });
      }, [setLoading]);
  return ( 
    <>
        <FounderBanner founderBannerData={founderBannerData} />
        <FounderMember founderMemberData={founderMemberData}/>
        <FounderMessage founderMessageData={founderMessageData}/>
    </>
  )
}

export default Founder